import { forwardRef, Ref, useEffect } from 'react';
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import { usePwcNavigate } from '@core/hooks/routing-hooks';

export type PwcNavLinkProps = Omit<NavLinkProps, 'to'> & {
  route: string;
  disabled?: boolean;
  params?: Record<string, string>;
  preserveSearch?: boolean;
};

const PwcNavLink = (
  { route, disabled, params, preserveSearch, children, ...rest }: PwcNavLinkProps,
  ref?: Ref<HTMLAnchorElement>
) => {
  const { generatePath } = usePwcNavigate();
  const location = useLocation();

  const handleClick = (e: any) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    const disabledNavLinks = document.getElementsByClassName('disabled');
    for (const element of disabledNavLinks) {
      element.removeAttribute('href');
    }
  }, [disabled]);

  const path = generatePath(route, params);
  const to = preserveSearch && location.search ? `${path}${location.search}` : path;

  return (
    <NavLink ref={ref} {...rest} to={to} onClick={handleClick}>
      {children}
    </NavLink>
  );
};

export default forwardRef(PwcNavLink);
